<template>
  <v-container class="rating-items">
    <rating-item v-for="beer in beers" :key="beer.id" :beer="beer" />
  </v-container>
</template>
<script>
import RatingItem from './RatingItem'

export default {
  components: {RatingItem},
  computed: {
    beers () {
      return this.$store.getters.rateBeers
    }
  }
}
</script>
<style lang="scss">
  .rating-items {
    margin-bottom: 60px;
  }
</style>
